import { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";
import { BRAND_THEME } from "@/lib/constants";
import { PageHeader } from "@/components/common";
import { BrandAnalytics } from "@/components/analytics/BrandAnalytics";

const BRANDS = ["Nini's Kitchen", "Niro", "Baked By Nini's"];
const DEFAULT = { preset: "last7", from: "", to: "", compare: true, outlets: [], dept: "" };

const BrandTabs = ({ brands, brand, onChange }) => (
  <div role="tablist" className="no-scrollbar mb-6 flex gap-2 overflow-x-auto border-b border-slate-200" data-testid="brand-tabs">
    {brands.map((b) => {
      const on = b === brand;
      return (
        <button key={b} role="tab" aria-selected={on} onClick={() => onChange(b)} data-testid={`brand-tab-${b.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          className={`relative flex shrink-0 items-center gap-2 px-4 pb-3 pt-2 text-sm font-semibold transition-colors sm:text-base ${on ? "text-slate-900" : "text-slate-400 hover:text-slate-700"}`}>
          <span className="h-2.5 w-2.5 rounded-full" style={{ background: BRAND_THEME[b].primary }} />{b}
          {on && <span className="absolute inset-x-0 -bottom-px h-[3px] rounded-full" style={{ background: BRAND_THEME[b].primary }} />}
        </button>
      );
    })}
  </div>
);

export default function Dashboard() {
  const { activeBrand, setBrand } = useApp();
  const { user } = useAuth();
  const brands = user?.brands?.length ? BRANDS.filter((b) => user.brands.includes(b)) : BRANDS;
  const brand = brands.includes(activeBrand) ? activeBrand : brands[0];
  const [settings, setSettings] = useState({});
  const s = settings[brand] || DEFAULT;
  const update = (patch) => setSettings((x) => ({ ...x, [brand]: { ...(x[brand] || DEFAULT), ...patch } }));
  useEffect(() => {
    if (activeBrand !== brand) setBrand(brand);
  }, [activeBrand, brand, setBrand]);

  return (
    <div data-testid="dashboard-page">
      <PageHeader title="Dashboard" subtitle="How each brand is doing, what customers complain about, and what to fix next." />
      <BrandTabs brands={brands} brand={brand} onChange={setBrand} />
      <BrandAnalytics key={brand} brand={brand} s={s} update={update} />
    </div>
  );
}
